module.exports = __webpack_public_path__ + "static/media/fly0172.0fd7460d.webp";